<template>
  <el-table :data="tableData" stripe style="width: 100%" ref="stationTable" border v-loading="stationsLoading">
    <af-table-column prop="stationName" label="充电站名称"></af-table-column>
    <af-table-column prop="stationCode" label="充电站编号"></af-table-column>
    <af-table-column prop="operatorName" label="运营商"></af-table-column>
    <af-table-column prop="city" label="所在地"></af-table-column>
    <af-table-column width="80" prop="pileCount" label="桩数量"></af-table-column>
    <af-table-column width="80" prop="dutyPerson" label="负责人"></af-table-column>
    <af-table-column width="110" prop="dutyPersonPhone" label="负责人手机号"></af-table-column>
    <af-table-column prop="serviceBillingRulesName" label="费率组"></af-table-column>
    <af-table-column width="120" prop="stationType.message" label="类型"></af-table-column>
    <af-table-column width="120" label="运行状态">
      <template slot-scope="{row}">
        <div v-if="row.stationStatus">
          <el-tag :type="row.stationStatus.code | statusFilter">
            {{ row.stationStatus.message }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <!--                <af-table-column width="80" prop="canUse.message" label="是否启用"></af-table-column>-->
    <af-table-column label="操作" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="showViewVisible(scope.$index, scope.row)"
                   >视图
        </el-button>
        <el-button size="mini" plain @click="stationEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:station:updateStation'])">编辑
        </el-button>
        <el-button size="mini" plain type="danger" @click="stationDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:station:deleteStation'])">删除
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{
      }
    },
    props:{
      tableData: {},
      stationsLoading: false,
    },
    methods:{
      showViewVisible(index,row){
        this.$emit('showViewVisible',index,row)
      },
      stationEdit(index,row){
        this.$emit('stationEdit',index,row)
      },
      stationDelete(index,row){
        this.$emit('stationDelete',index,row)
      }
    },
    filters: {
      statusFilter(stationStatus) {
        const statusMap = {
          0: 'warning',
          1: 'primary',
          5: 'info',
          6: 'danger',
          50: 'success'
        }
        return statusMap[stationStatus]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/siteManager/list.vue